<template>
    <form-wrapper class="account-information-form" @submit="handleFormSubmission(data)">
        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.change_email.fields.email.change_email')"
                    :placeholder="$t('forms.change_email.fields.email.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    type="email"
                    valuePath="email"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.change_email.fields.email.confirm_email')"
                    :placeholder="$t('forms.change_email.fields.email.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    :error="confirmEmailError"
                    type="email"
                    valuePath="confirmEmail"
                    @change="confirmEmailChange($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('forms.change_email.buttons.cancel')"
                    :isSubmittable="false"
                    type="secondary"
                    size="large"
                    @click="emitEvent({ name: 'cancel' })"
                ></common-button>
                <common-button :label="$t('forms.change_email.buttons.save')" size="large" type="primary"></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import UsersAPI from 'api/UsersAPI'

    export default {
        mixins: [FormMixin, HandleRequestMixin],

        data() {
            return {
                confirmEmailError: '',
            }
        },

        methods: {
            handleFormSubmission(data) {
                if (data.email !== data.confirmEmail) {
                    return (this.confirmEmailError = this.$t('forms.change_email.not_matching'))
                }
                this.handleRequest(UsersAPI.update(this.$auth.getUser().id, { email: data.email }))
                    .then(() => {
                        this.emitEvent({ name: 'success' })
                        this.$auth.logOut()
                        this.$router.push({ name: 'auth.login' })
                    })
                    .catch(() => {})
            },

            confirmEmailChange(event) {
                this.confirmEmailError = ''
                this.change(event)
            },
        },
    }
</script>
